module.exports = __webpack_public_path__ + "be229de5a86e3147fef6968ce055038e.MP3";